export default __webpack_public_path__ + "static/media/OSH_PoweredBy.e4656bf5.png";